import React from "react";
import { StumpageTypeForm } from "../Stampage/AddStampage";

const AddLif = () => <StumpageTypeForm kind="lif" />;

export default AddLif;
